const e = {
  name: "Timer",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C12.5523 7 13 7.44772 13 8V11.5858L14.7071 13.2929C15.0976 13.6834 15.0976 14.3166 14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071L11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12V8C11 7.44772 11.4477 7 12 7Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C8.44772 0 8 0.447715 8 1C8 1.55228 8.44772 2 9 2H11V3.05493C6.50005 3.55237 3 7.36745 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.36745 17.5 3.55237 13 3.05493V2H15C15.5523 2 16 1.55228 16 1C16 0.447715 15.5523 0 15 0H9ZM5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0711 2.10051C18.6806 1.70999 18.0474 1.70999 17.6569 2.10051C17.2664 2.49103 17.2664 3.1242 17.6569 3.51472L20.4853 6.34315C20.8758 6.73368 21.509 6.73368 21.8995 6.34315C22.29 5.95263 22.29 5.31946 21.8995 4.92894L19.0711 2.10051Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as Timer
};
